<script setup>

const props = defineProps({
    review: Object,
});
</script>

<template>
    <div class="flex flex-col items-center justify-center">
        <div class="text-xl text-center md:text-3xl" v-html="review.review" v-if="review.review"></div>

        <div class="flex flex-col items-center mt-10">
            <p class="text-sm uppercase">{{ review.name }}</p>
            <p class="mt-1 text-sm uppercase text-primary-inverted">{{ review.position }}</p>

        </div>

        <slot></slot>
    </div>
</template>
